import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChildren } from '@angular/core';
import * as R from 'ramda';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ChartComponent } from './../chart/chart.component';

const highlight = R.curry((event, chart) => chart.highlightPoint(event));

const unsetHighlightedPoint = (chart) => chart.unsetHighlightedPoint();

@Component({
  selector: 'app-synchronized-charts',
  templateUrl: './synchronized-charts.component.html',
  styleUrls: ['./synchronized-charts.component.css']
})
export class SynchronizedChartsComponent implements OnChanges {
  height: number;
  dimensionedCharts$: Observable<any[]>;
  @Input() charts: any[];
  @Output() select = new EventEmitter<any>();
  @ViewChildren(ChartComponent) chartComponents: ChartComponent[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['charts']) {
      this.height = (this.charts.length) ? 100 / this.charts.length : 100;
      this.dimensionedCharts$ = of(this.charts);
    }
  }

  synchronizeCharts(event) {
    this.chartComponents.forEach(highlight(event));
  }

  unsetSynchronization() {
    this.chartComponents.forEach(unsetHighlightedPoint);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/charts/synchronized-charts/synchronized-charts.component.ts